'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changeLanguage = changeLanguage;
exports.setLangFromUrl = setLangFromUrl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = require('../../config');

var CHANGE_LANG = 'redux-example/CHANGE_LANG';
var SET_LANG_FROM_URL = 'redux-example/SET_LANG_FROM_URL';

var initialState = {
  lang: 'es',
  nextLang: 'en'
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_LANG:
      return (0, _extends3.default)({}, state, {
        lang: action.newLang,
        nextLang: action.nextLang
      });
    case SET_LANG_FROM_URL:
      return (0, _extends3.default)({}, state, {
        lang: action.newLang,
        nextLang: action.nextLang
      });
    default:
      return state;
  }
}

function changeLanguage(actualLang, location, browserHistory) {
  var newLang = actualLang === 'es' ? 'en' : 'es';
  var actualUrl = location.pathname;

  /*Separamos url en un array por '/' y limpiamos los vacíos para obtener el último pathname*/
  var aUrl = actualUrl.split("/");
  var actualPath = aUrl.filter(function (value) {
    return (0, _keys2.default)(value).length !== 0;
  }).pop();

  var newPath = config.urlTraduction[actualPath];

  actualUrl = actualUrl.replace('/' + actualLang + '/', '/' + newLang + '/');
  if (typeof newPath !== "undefined") {
    actualUrl = actualUrl.replace('/' + actualPath + '/', '/' + newPath + '/');
  }
  browserHistory.push(actualUrl);
  return {
    type: CHANGE_LANG,
    newLang: newLang,
    nextLang: actualLang
  };
}

function setLangFromUrl(newLang, nextLang) {
  return {
    type: SET_LANG_FROM_URL,
    newLang: newLang,
    nextLang: nextLang
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/language.js
// module id = 354
// module chunks = 0